<template>
  <Modal
    :modal-active="isOpen"
    :has-header-border="true"
    :has-footer-border="true"
    max-width="max-w-3xl"
    max-height="90vh"
    data-testid="check-verification-modal"
    @close="close"
  >
    <template #header>
      <div class="flex items-center gap-3 flex-wrap">
        <h2 class="text-lg text-left text-textPrimary font-bold">{{ title }}</h2>
        <LabelBadge
          v-if="context"
          :label="context.coverageLabel"
          :color="context.coverageColor"
          size="small"
          :icon="null"
          data-testid="verification-coverage-chip"
        />
        <span v-if="checkId" class="text-xs font-mono bg-[#E2E2E9] px-2 py-0.5 rounded"
          >#{{ checkId }}</span
        >
      </div>
    </template>

    <!-- Casca fina: todo o corpo (fetch, fotos, mapa, barra de status) mora no
         painel, que também é montado numa aba do modal de evidências do plantão.
         O `Modal` destrói o slot ao fechar, então o painel desmonta, revoga as
         blob URLs e para de buscar — não há gatilho de `isOpen` aqui dentro. -->
    <CheckVerificationPanel
      :check-id="checkId"
      @loaded="context = $event"
      @failed="context = null"
    />

    <template #footer>
      <div class="flex justify-end gap-2">
        <OutlineButton
          v-if="context?.mapsUrl"
          text="Abrir no Google Maps ↗"
          width="auto"
          height="32px"
          @click="openMaps"
        />
        <OutlineButton
          text="Fechar"
          width="100px"
          height="32px"
          data-testid="verification-close-button"
          @click="close"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import CheckVerificationPanel from './CheckVerificationPanel.vue'
import type { CheckVerificationContext } from './CheckVerificationPanel.vue'

const props = defineProps<{ isOpen: boolean; checkId: number | null }>()
const emit = defineEmits<{ (e: 'update:isOpen', v: boolean): void }>()

const context = ref<CheckVerificationContext | null>(null)

const title = computed(() => context.value?.title ?? 'Verificação do registro')

// Fechar ou trocar de check zera o cabeçalho: sem isso o chip de cobertura do
// check anterior apareceria por um instante na próxima abertura.
watch(
  () => [props.isOpen, props.checkId],
  () => {
    context.value = null
  }
)

function openMaps() {
  const url = context.value?.mapsUrl
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}

function close() {
  emit('update:isOpen', false)
}
</script>
